(() => {
  if (customElements.get('adm-home-carousel')) return;

  class AdmHomeCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.section = this.closest('.adm-home-carousel-section');
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.captions = Array.from(this.section?.querySelectorAll('[data-caption]') || []);

      this.total = this.slides.length;
      this.currentIndex = 0;
      this.timer = null;

      if (!this.track || this.total === 0) return;

      this.dataset.initialized = 'true';

      this.updateHeaderHeight = this.updateHeaderHeight.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleTouchStart = this.handleTouchStart.bind(this);
      this.handleTouchEnd = this.handleTouchEnd.bind(this);

      this.startX = 0;
      this.startY = 0;

      this.updateHeaderHeight();

      window.addEventListener('resize', this.updateHeaderHeight);
      window.addEventListener('orientationchange', this.updateHeaderHeight);
      document.addEventListener('shopify:section:load', this.updateHeaderHeight);

      this.addEventListener('keydown', this.handleKeydown);
      this.addEventListener('touchstart', this.handleTouchStart, { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd, { passive: true });

      this.goTo(0, false);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();

      window.removeEventListener('resize', this.updateHeaderHeight);
      window.removeEventListener('orientationchange', this.updateHeaderHeight);
      document.removeEventListener('shopify:section:load', this.updateHeaderHeight);

      this.removeEventListener('keydown', this.handleKeydown);
      this.removeEventListener('touchstart', this.handleTouchStart);
      this.removeEventListener('touchend', this.handleTouchEnd);
    }

    updateHeaderHeight() {
      const header =
        document.querySelector('.shopify-section-header') ||
        document.querySelector('#shopify-section-header') ||
        document.querySelector('sticky-header') ||
        document.querySelector('.header-wrapper') ||
        document.querySelector('header');

      this.section?.style.setProperty('--adm-header-height', `${header ? header.offsetHeight : 0}px`);
    }

    handleKeydown(event) {
      if (event.key === 'ArrowUp') this.goTo(this.currentIndex - 1);
      if (event.key === 'ArrowDown') this.goTo(this.currentIndex + 1);
    }

    handleTouchStart(event) {
      this.startX = event.changedTouches[0].screenX;
      this.startY = event.changedTouches[0].screenY;
    }

    handleTouchEnd(event) {
      const endX = event.changedTouches[0].screenX;
      const endY = event.changedTouches[0].screenY;

      const distanceX = endX - this.startX;
      const distanceY = endY - this.startY;

      if (Math.abs(distanceY) < 40) return;
      if (Math.abs(distanceY) < Math.abs(distanceX)) return;

      this.goTo(distanceY > 0 ? this.currentIndex - 1 : this.currentIndex + 1);
    }

    goTo(index, restart = true) {
      if (index < 0) {
        this.currentIndex = this.total - 1;
      } else if (index >= this.total) {
        this.currentIndex = 0;
      } else {
        this.currentIndex = index;
      }

      const movePercent = (100 / this.total) * this.currentIndex;

      this.track.style.transform = `translate3d(0, -${movePercent}%, 0)`;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.currentIndex;

        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this.captions.forEach((caption, captionIndex) => {
        const isActive = captionIndex === this.currentIndex;

        caption.classList.toggle('is-active', isActive);
        caption.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      if (restart) {
        this.restartAutoplay();
      }
    }

    startAutoplay() {
      if (this.dataset.autoplay !== 'true') return;
      if (this.total <= 1) return;

      const interval = Number(this.dataset.interval) || 5000;

      this.stopAutoplay();

      this.timer = window.setInterval(() => {
        this.goTo(this.currentIndex + 1, false);
      }, interval);
    }

    stopAutoplay() {
      if (!this.timer) return;

      window.clearInterval(this.timer);
      this.timer = null;
    }

    restartAutoplay() {
      if (this.dataset.autoplay === 'true') {
        this.startAutoplay();
      }
    }
  }

  customElements.define('adm-home-carousel', AdmHomeCarousel);
})();